import PubSub from "./utils/PubSub"; // Make sure PubSub is imported

// --- Facebook Pixel AddToCart Event Listener ---
PubSub.subscribe("fetch:addToCart:success", ({ data }) => {
  console.log("AddToCart Success Event Received:", data); // Debug log

  if (typeof fbq === "function" && data && data.added_item) {
    // Check if fbq exists and the necessary added_item data is present
    console.log("Firing FB Pixel AddToCart event for:", data.added_item); // Debug log

    try {
      const itemData = data.added_item;
      const price = parseFloat(itemData.price);
      const quantity = parseInt(itemData.quantity, 10) || 1;

      // Ensure price and quantity are valid numbers
      if (!isNaN(price) && price > 0 && !isNaN(quantity) && quantity > 0) {
        fbq("track", "AddToCart", {
          content_type: "product",
          // Use content_id provided by backend (includes 'wc_' prefix)
          content_ids: [itemData.content_id],
          content_name: itemData.name,
          currency:
            itemData.currency ||
            (window.woocommerce_params && window.woocommerce_params.currency) ||
            "TRY", // Fallback currency
          value: price, // Pass the unit price
          num_items: quantity,
        });
        console.log("FB Pixel AddToCart Fired Successfully."); // Debug log
      } else {
        console.warn(
          "FB Pixel AddToCart: Invalid price or quantity.",
          itemData
        );
      }
    } catch (pixelError) {
      console.error("Facebook Pixel AddToCart Error:", pixelError);
    }
  } else {
    if (typeof fbq !== "function") {
      console.warn("FB Pixel AddToCart: fbq function not found.");
    }
    if (!data || !data.added_item) {
      console.warn(
        "FB Pixel AddToCart: Missing added_item data in response.",
        data
      );
    }
  }
});
// --- End Facebook Pixel AddToCart Event Listener ---
